import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UploadResume from './UploadResume'; 
import HeaderComponent from './HeaderComponent';
import ReportComponent from './Report';
import Login from './Login';

function App() {
  return (
    <div>
    <HeaderComponent />
    <Router>
          <Routes>
            <Route path="/" element={<UploadResume />} />
            <Route path="/login" element={<Login />} />
            <Route path="/report" element={<ReportComponent />} />
            {/* Add more routes here as needed */}
          </Routes>
        </Router>
    </div>
  );
}

export default App;